export enum SessionStorageKeys {
    referer = 'referer',
}
